import { Card, Col, Row, Skeleton } from '@repo/ui/components'

interface DashboardEstimatedAssetsSkeletonProps {
  isDesktop?: boolean
}

export const DashboardEstimatedAssetsSkeleton = (
  props: DashboardEstimatedAssetsSkeletonProps,
) => {
  const { isDesktop = false } = props
  if (isDesktop)
    return (
      <Card className='p-md md:p-md hidden md:flex flex-col md:flex-row items-start md:items-center justify-between w-full gap-md md:gap-0'>
        <Col className='gap-xs md:gap-md flex-1'>
          <Skeleton className='w-32 h-4 mb-2' />
          <Row className='items-center gap-sm md:gap-md'>
            <Row className='gap-2xs md:gap-xs w-fit'>
              <Skeleton className='w-28 h-5 rounded-md' />
              <Skeleton className='w-12 h-5 rounded-md' />
              <Skeleton className='w-7 h-5 rounded-full' />
            </Row>
            <Skeleton className='w-32 h-4' />
          </Row>
        </Col>
        <Col className='items-end gap-sm md:gap-md'>
          <Skeleton className='w-20 h-6 rounded-md mb-2' />
          <Skeleton className='w-32 h-5 rounded-full' />
        </Col>
      </Card>
    )
  return (
    <Card className='p-sm md:p-lg w-full max-w-container-md flex md:hidden'>
      <Col className='gap-md w-full'>
        <Row className='justify-between items-center w-full'>
          <Skeleton className='w-16 h-4' />
          <Skeleton className='w-10 h-4' />
        </Row>

        <Row className='justify-between items-center w-full gap-sm'>
          <Row className='items-center gap-xs'>
            <Skeleton className='w-8 h-8 rounded-full' />
            <Skeleton className='w-16 h-6' />
          </Row>
          <Skeleton className='w-10 h-4' />
        </Row>

        <Row className='w-full'>
          <Skeleton className='w-full h-6 rounded-md' />
        </Row>
      </Col>
    </Card>
  )
}
